import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TrackLists from "./TrackLists";
import VinylFlip from "./VinylFlip";
import VinylCovers from "./VinylCovers";
import PurchasePanel from "./PurchasePanel";
import ProductDescr from "./ProductDescr";
// import frontCover from "../../assets/CoversFront/cover1.png";
// import backCover from "../../assets/CoversBack/cover1.png";
import ArabicVinylData from "../ArabicVinyl/ArabicVinylData";
import { useCart } from "../Cart/CartContext";
import "./Products.css";
import api from "../../api";

const CategoryCarouselV2 = lazy(
  () => import("../CategoryCarousel/CategoryCarouselV2"),
);
const Loader = () => <div style={{ height: "350px" }} />


const Products = () => {
  const {
    // cartItems,
    addToCart,
    // removeItem,
    // increaseQty,
    // decreaseQty
  } = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  //console.log(cartOpen);

  const toPublicUrl = (p) => {
    const value = (p || "").trim();

    if (!value || value.toLowerCase() === "n/a") {
      return "";
    }

    const clean = `/assets/images/${value}`;
    return `${api.defaults.baseURL.replace(/\/$/, "")}${encodeURI(clean)}`;
  };
  
  const { id } = useParams();
  const [productsData, setProductsData] = useState([]);
  const [product, setProduct] = useState(null);

  const [catData, setCatData] = useState([]);
  //
  useEffect(() => {
    if (!id) return;
    //
    const CatData = async () => {
      try {
        const formData = new FormData();
        formData.append("Action", "getCategories");
        formData.append("productId", id);
        const res = await api.post("categories", formData);
        setCatData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    CatData();
  }, [id]);
  //
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [id]);

  useEffect(() => {
    if (!id) return;
    //
    const ProductsData = async () => {
      try {
        const formData = new FormData();
        formData.append("Action", "getProductInfo");
        formData.append("productId", id);
        const res = await api.post("products", formData);
        setProductsData(res.data);
        setProduct(res.data?.[0] ?? null);
        //console.log("products ", productsData);
        //console.log("product ", product);
      } catch (err) {
        console.error(err);
      }
    };
    ProductsData();
  }, [id]);

  // optional: if you want to log after state updates
  useEffect(() => {
    // console.log("productsData state:", productsData);
    console.log("product state:", product);
  }, [productsData, product]);
  // useEffect(() => {
  //     ProductsData();
  // }, []);

  // before return:
  if (!product) {
    return <div style={{ padding: 30 }}>Loading...</div>;
  }

  return (
    <section className="vinyl-section-p">
      <div className="vinyl-top-row">
        <div className="vinyl-top-left">
          <div className="vinyl-left-row">
            {/* <VinylCovers frontSrc={frontCover} backSrc={backCover} /> */}
            <VinylCovers
              frontSrc={toPublicUrl(product?.cover_front)}
              backSrc={toPublicUrl(product?.cover_back)}
            />
            <VinylFlip
              frontSrc={toPublicUrl(product?.cover_front)}
              backSrc={toPublicUrl(product?.cover_back)}
            />
          </div>
        </div>

        <div className="vinyl-top-right">
          <PurchasePanel product={product} categories={catData} />
        </div>
      </div>
      <div className="vinyl-tracklist">
        <TrackLists product={product} />
      </div>
      {(product?.descriptionEn || product?.descriptionAr) && (
        <div className="vinyl-description-block">
          <ProductDescr
            isArabicVinyl={!!product.artistAr}
            titleEN={product.titleEn}
            titleAR={product.titleAr}
            descriptionEN={product.descriptionEn}
            descriptionAR={product.descriptionAr}
            artist={product.artistEn}
            artistAr={product.artistAr}
          />
        </div>
      )}
      <Suspense fallback={<Loader />}>
        <CategoryCarouselV2
          id="relative-vinyl"
          title="Related Vinyl"
          relative={1}
          product={product}
          //ArabicVinylData={ArabicVinylData}
          onAddToCart={(item, qty = 1, sourceEl = null) => {
            addToCart(item, qty, sourceEl);
            // setCartOpen(true);
          }}
          direction="ltr"
        />
      </Suspense>
    </section>
  );
};

export default Products;
